export default "__VITE_ASSET__61583882__"